import { render } from "./Book.vue?vue&type=template&id=5e5152cc&scoped=true"
import script from "./Book.vue?vue&type=script&lang=js"
export * from "./Book.vue?vue&type=script&lang=js"

import "./Book.vue?vue&type=style&index=0&id=5e5152cc&lang=scss&scoped=true"
import "./Book.vue?vue&type=style&index=1&id=5e5152cc&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e5152cc"]])

export default __exports__